
export function GenerateFileName() {
    const now= new Date();
    const dateString = now.getFullYear().toString() + now.getMonth().toString().padStart(2, '0') + now.getDate().toString().padStart(2, '0')
    const timeString = now.getHours().toString().padStart(2, '0') +':'+ now.getMinutes().toString().padStart(2, '0') +':'+ now.getSeconds().toString().padStart(2, '0')
    const fileName = `manualPEM${dateString}_${timeString}.pem`
    return fileName;
}
